export const ENV_APP_NAME = '/appactivation';
export const API_TIME_OUT = 100000; //use this later #{ServerCallTimeOut}

export const HOST = {
	BASE_APIM_URL: '#{BaseURL-API}',
	BASE_HCM_URL: '#{BaseURL-HCM}',
	BASE_SECURE_URL: '#{BaseURL-Secure}',
	BASE_DEVELOPER_PORTAL_URL: '#{BaseURL-DevelopersPortal}',
	UI_URL_BASE: '#{BaseURL-HCM}' + ENV_APP_NAME,
	PUBLIC_API_URL_BASE: '#{BaseURL-Public-API}',
	environment: '#{Octopus.Environment.Name | tolower}',
	APIM_SUBSCRIPTION_KEY: '#{Project-APIm-Key}',
	AUTHENTICATION_URL: '#{BaseURL-HCM}',
	SESSION_TIMEOUT_LOCAL_MODE: false,
	CODE_VERIFIER: 'CA1d7NlwyPsKNbx~SCnBy-yqx98vJsh8AHA_NNsP.fHTJGlgtrKWVcvBGmVyaJ6HVhWOTQkTmX7v~RxHipdY.PdB3fntH3kfWFnESobpPsXQ23Z.6_.gl7IP_zVyIN-n'
};

export const securitySettings = {
	client_id: 'AppActivationUIAppId',
	redirect_uri: `${HOST.UI_URL_BASE}/oauth/silent_renew.html`,
	response_type: 'token',
	scope: 'appactivationUi',
	authority: `${HOST.BASE_APIM_URL}/sts/v1/common`,
	silent_redirect_uri: `${HOST.UI_URL_BASE}/oauth/silent_renew.html`,
	automaticSilentRenew: true,
	filterProtocolClaims: true,
	loadUserInfo: true,
	includeIdTokenInSilentRenew: false,
	extraQueryParams: { 'subscription-key': HOST.APIM_SUBSCRIPTION_KEY }
};
